import { render } from "./CardOptionsForm.vue?vue&type=template&id=fd2c4160&scoped=true"
import script from "./CardOptionsForm.vue?vue&type=script&lang=js"
export * from "./CardOptionsForm.vue?vue&type=script&lang=js"

import "./CardOptionsForm.vue?vue&type=style&index=0&id=fd2c4160&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2c4160"]])

export default __exports__